import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {RadioButton} from "./radio-button";
import {RadioButtonViewModel} from "./radio-button.view-model";

class RadioButtonsProps extends BaseProps {
  selections: Array<RadioButtonViewModel>;
  onChange: Function;
}

export const RadioButtons = observer((props: RadioButtonsProps) => {
  return (
    <div className={'radio-buttons'}>
      {
        props.selections.map((item: RadioButtonViewModel) => <RadioButton
          key={item.id}
          label={item.name}
          isActive={item.checked}
          onClick={() => props.onChange(item.type)}
        />)
      }
    </div>
  )
});
